module.exports = __webpack_public_path__ + "img/spruce-winter-icon.d90e5548.png";